import { getEndOfDay, getStartOfDay } from '../../constants/DateUtil';
import { generateObjectWithCriteriaMode, getCombined } from '../../sagas/util';
import { getStringFromObject } from '../../constants/lodashUtils';

export const PATIENT_PORTAL_INTEGRATION_STATES = {
    REQUESTED: 'REQUESTED',
    APPROVED: 'APPROVED',
    REVOKED: 'REVOKED',
};

export const patientPortalIntegratedPatientsSchema = {
    fieldType: 'materialTable',
    id: 'table',
    name: 'patientPortalIntegratedPatients',
    showInNonEditableMode: true,
    showInReadOnlyMode: true,
    hideCheckBoxIcon: true,
    rowstyle: {
        height: '56px',
    },
    headerColStyle: {
        color: '#000000',
        fontSize: '14px',
    },
    tableCells: [
        {
            id: 'requestedAt',
            name: 'requestedAt',
            find: 'requestedAt',
            label: 'Requested Date',
            fieldType: 'datetime',
        },
        {
            id: 'patientIdentifier',
            name: 'patientIdentifier',
            find: 'patientIdentifier',
            label: 'Patient Identifier',
            fieldType: 'text',
        },
        {
            id: 'patientName',
            name: 'patientName',
            find: 'patientName',
            label: 'Patient Name',
            fieldType: 'text',
        },
        {
            id: 'state',
            name: 'state',
            find: 'state',
            label: 'State',
            fieldType: 'text',
        },
        {
            id: 'requestedUserName',
            name: 'requestedUserName',
            find: 'requestedUserName',
            label: 'Requested By',
            fieldType: 'text',
        },
        {
            id: 'viewDetails',
            name: 'viewDetails',
            label: 'Details',
            fieldType: 'actionButton',
            buttonLabel: 'View',
            headerStyle: {
                fontSize: '14px',
                width: '8%',
            },
        },
    ],
    grid: {
        sm: 12,
        md: 12,
        lg: 12,
    },
};

export const generatePatientPortalIntegrationSearchConstruct = (filters) => {
    const startDate = getStringFromObject('datePeriod.startDate', filters);
    const endDate = getStringFromObject('datePeriod.endDate', filters);

    if (!startDate || !endDate) {
        return null;
    }

    let searchConstruct = null;
    if (startDate && endDate) {
        searchConstruct = getCombined(
            searchConstruct,
            'AND',
            getCombined(
                generateObjectWithCriteriaMode(
                    'patient_portal_integration.requestedAt',
                    getStartOfDay(new Date(startDate)).getTime(),
                    '>=',
                ),
                'AND',
                generateObjectWithCriteriaMode(
                    'patient_portal_integration.requestedAt',
                    getEndOfDay(new Date(endDate)).getTime(),
                    '<=',
                ),
            ),
        );
    }

    const patientUuid = getStringFromObject('patient.key', filters);
    if (patientUuid) {
        searchConstruct = getCombined(
            searchConstruct,
            'AND',
            generateObjectWithCriteriaMode('person.uuid', patientUuid, '='),
        );
    }

    const stateKey = getStringFromObject('state.key', filters);
    if (stateKey) {
        searchConstruct = getCombined(
            searchConstruct,
            'AND',
            generateObjectWithCriteriaMode('patient_portal_integration.state', stateKey, '='),
        );
    }

    return searchConstruct;
};
